import {
  Http,
  Response,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { UnitType } from "../model/unitType";

@Injectable({
  providedIn: 'root'
})
export class UnitTypeService {
  uniTypeApiUrl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.uniTypeApiUrl = environment.uniTypeApiUrl;
  }

  create(unitType: UnitType) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.uniTypeApiUrl + '/create', unitType, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getUnitTypes(query=null) {
    let url = this.uniTypeApiUrl + '/getall';
    if(query?.startDateTime){
      url = url + `?startDateTime=${query?.startDateTime}`
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  update(id: string, unitType: UnitType) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.uniTypeApiUrl + '/update/' + id, unitType, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  remove(id: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.uniTypeApiUrl + '/' + id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
